import { useMemo } from 'react';
import { mapValues, keyBy } from 'lodash-es';

import type { FormFieldAnswer } from '@duke-hq/shared-constants/assessments';

export function useAssessmentFormWithAnswers(formFields: FormFieldAnswer[]) {
  return useMemo(() => {
    const answerMap = new Map(formFields.map((a) => [a.fieldId, a]));

    // Only incorrect fields go in formSlideState (these need student input)
    const editableFields = formFields.filter(({ correct }) => correct !== true);
    const formSlideState = mapValues(keyBy(editableFields, 'fieldId'), (field) => ({
      textInputValue: field.textInputValue ?? '',
      selectedOptions: field.selectedOptions ?? [],
    }));

    return { answerMap, formSlideState };
  }, [formFields]);
}
